/**
 * Um site fictício atrás do widget.
 *
 * Não é enfeite: o widget é um botão flutuante sobre a página de outra pessoa. Avaliado num fundo
 * vazio, é impossível julgar se a posição, o deslocamento e o contraste funcionam. Com uma página
 * por baixo, dá para ver o que o visitante vê — inclusive se o botão cobre algo importante.
 *
 * O conteúdo é marcado como decorativo (`aria-hidden`) para não poluir leitores de tela nem
 * competir com a conversa, que é o que está sendo testado.
 */

export function SimulatedSite({ title }: { title: string }) {
  return (
    <div aria-hidden="true" className="pointer-events-none h-full w-full overflow-hidden bg-white select-none">
      <div className="flex items-center gap-3 border-b border-slate-200 px-6 py-4">
        <div className="h-6 w-6 rounded bg-slate-300" />
        <div className="h-3 w-28 rounded bg-slate-300" />
        <div className="ml-auto flex gap-4">
          {[44, 36, 52].map((width) => (
            <div key={width} className="h-2.5 rounded bg-slate-200" style={{ width }} />
          ))}
        </div>
      </div>

      <div className="space-y-3 px-6 py-8">
        <p className="text-xs font-semibold tracking-widest text-slate-400 uppercase">
          site de exemplo — {title}
        </p>
        <div className="h-7 w-3/4 rounded bg-slate-200" />
        <div className="h-7 w-1/2 rounded bg-slate-200" />
        <div className="space-y-2 pt-3">
          {['92%', '86%', '78%', '88%', '64%'].map((width, index) => (
            <div key={index} className="h-2.5 rounded bg-slate-100" style={{ width }} />
          ))}
        </div>
        <div className="grid grid-cols-3 gap-3 pt-6">
          {[0, 1, 2].map((index) => (
            <div key={index} className="space-y-2 rounded-lg border border-slate-200 p-3">
              <div className="h-14 rounded bg-slate-100" />
              <div className="h-2.5 w-2/3 rounded bg-slate-200" />
              <div className="h-2 w-full rounded bg-slate-100" />
              <div className="h-2 w-4/5 rounded bg-slate-100" />
            </div>
          ))}
        </div>
        <div className="space-y-2 pt-6">
          {['90%', '82%', '70%'].map((width, index) => (
            <div key={index} className="h-2.5 rounded bg-slate-100" style={{ width }} />
          ))}
        </div>
      </div>
    </div>
  );
}
